import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_FEE_PRICING_ACTION_TYPE } from '../actions';

const initialState = {
  appraisalFeePricings: {},
};

const appraisalFeePricingReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case APPRAISAL_FEE_PRICING_ACTION_TYPE.GET_APPRAISAL_FEE_PRICINGS:
        draft.appraisalFeePricings = payload || initialState.appraisalFeePricings;
        break;

      case APPRAISAL_FEE_PRICING_ACTION_TYPE.CREATE_APPRAISAL_FEE_PRICING:
      case APPRAISAL_FEE_PRICING_ACTION_TYPE.UPDATE_APPRAISAL_FEE_PRICING:
        draft.appraisalFeePricings[payload.id] = payload;
        break;

      case APPRAISAL_FEE_PRICING_ACTION_TYPE.DELETE_APPRAISAL_FEE_PRICING:
        delete draft.appraisalFeePricings[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default appraisalFeePricingReducer;
